<template>

          <div class=" sa-col-lg5 sa-col-md6 sa-col-sm5 sa-col-xs5 sa-rate-progress">
              <div class="sa-right-border">
                <svg class="sa-prog-bar" viewBox="1.6 1.6 16.8 16.8">
                    <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="50%" stop-color="#005DFF"></stop>
                        <stop offset="100%" stop-color="#00D2FF"></stop>
                    </linearGradient>
                    <circle class="sa-prog-bar-bg" cx="10" cy="10" r="8"></circle>
                    <circle :style="{strokeDashoffset: MM}" cx="10" cy="10" r="8" fill="none" class="stroke" stroke="url(#linearColors)"></circle>
                    <text x="62%" y="70%">{{progBar.avg_rating}}</text>
                </svg>
              </div>
              <div>
                <span  class="sa-rr-icn">
                    <i v-for="item in 5" :key="item" :class=" progBar.avg_rating >= item ? 'icon-star' : (progBar.avg_rating > item - 1) ? 'icon-star-half':'icon-star-line'" :rating="progBar.avg_rating"></i>
                </span>
                <div class="sa-f-size20">{{progBar.rtg_count}}</div>
                <span>Total</span>
              </div>
          </div>
</template>
<script>
export default {
    props:['progBar'],
    data() {
    return {
    }
  },
  
  computed: {
    MM:function(){
      if(this.progBar){
        let percentage = ((this.progBar.avg_rating)/5) * 100
         let el = -50 - ((50 / 100) * percentage)
        return el
      }
    },
  },
}
</script>
<style scoped>
svg {transition: all .8s ease-in-out;}
svg.sa-prog-bar{overflow: visible;width:140px;}
.sa-prog-bar-bg {fill: none;stroke: #E9F3FF;stroke-width: 1.2;}
.stroke {fill: none;stroke-width: 0.5;stroke-dasharray: 50 50;stroke-dashoffset: -50;stroke-linecap: round; position: relative;}
/* .stroke:after {position: absolute;top: 0;left: 0;background: #FFF;width: 5px;height: 5px;border-radius: 100%;} */
.sa-prog-bar text {font-size: 4px;font-weight: 700;text-anchor: middle;fill: #000;}
.sa-rr-icn {display: block;}
</style>